import { type AutomationType } from '@repo/utils';

export const getAutomationList = `
query AutomationList(
  $filterOptions: JSON
  $sortOptions: JSON
  $limit: Int
  $offset: Int
) {
  automationList(
    filterOptions: $filterOptions
    sortOptions: $sortOptions
    limit: $limit
    offset: $offset
  ) {
    automations {
      id
      name
      description
      status
      appearanceType
      updatedAt
      createdAt
      updatedBy {
        ... on User {
          fullName
        }
      }
      triggerNode {
        nodeSubType
      }
    }
    totalCount
    limit
    offset
  }
}
`;

export interface AutomationListResponse {
  automationList: {
    automations: Omit<AutomationType, 'startsAt' | 'endsAt'>[];
    totalCount: number;
    limit: number;
    offset: number;
  };
}
